export const subjectVariablesSectionMessagesEn = {
  // Cohort Builder - Subject Variables Content
  'projects.cohortBuilderPage.subjectVariablesSection.title': 'Subject variables',
  'projects.cohortBuilderPage.subjectVariablesSection.buttonLabel': 'Create criterion',
  'projects.cohortBuilderPage.subjectVariablesSection.nameItemLabel': 'Name',
  'projects.cohortBuilderPage.subjectVariablesSection.typeItemLabel': 'Type',
  'projects.cohortBuilderPage.subjectVariablesSection.noSubjectVariablesMainMsg':
    'No subject variables',
  'projects.cohortBuilderPage.subjectVariablesSection.noSubjectVariablesSubMsg':
    'Set a subject variable to get started',

  // cohort builder components - SubjectVariableEditCard
  'projects.cohortBuilderPage.subjectVariableEditCard.titleAdd': 'Create criterion',
  'projects.cohortBuilderPage.subjectVariableEditCard.titleEdit': 'Edit criterion',
  'projects.cohortBuilderPage.subjectVariableEditCard.titleView': 'View criterion',
  'projects.cohortBuilderPage.subjectVariableEditCard.cancelBtn': 'Cancel',
  'projects.cohortBuilderPage.subjectVariableEditCard.closeBtn': 'Close',
  'projects.cohortBuilderPage.subjectVariableEditCard.saveBtn': 'Criterion',
  'projects.cohortBuilderPage.subjectVariableEditCard.description':
    'Subject variables are used to take event variables and roll them up to a person. They can also be variables that live at the subject level (e.g. Demographics).',
  'projects.cohortBuilderPage.subjectVariableEditCard.nameLabel': 'Name',
  'projects.cohortBuilderPage.subjectVariableEditCard.namePlaceholderLegacy':
    'Enter criterion name',
  'projects.cohortBuilderPage.subjectVariableEditCard.namePlaceholder': 'Enter name',
  'projects.cohortBuilderPage.subjectVariablesSection.addConceptFilter': 'Concept filter',
  'projects.cohortBuilderPage.subjectVariablesSection.addNumericFilter': 'Numeric filter',
  'projects.cohortBuilderPage.subjectVariablesSection.conceptFilterSection.title':
    'Concept filters',
  'projects.cohortBuilderPage.subjectVariablesSection.numericFilterSection.title':
    'Numeric filters',
  'projects.cohortBuilderPage.subjectVariablesSection.countFilterSection.title': 'Count filter',
  'projects.cohortBuilderPage.subjectVariableEditCard.cancelButtonText': 'Close',
  'projects.cohortBuilderPage.subjectVariableEditCard.ieCriteria.label': 'I/E criteria',
  'projects.cohortBuilderPage.subjectVariableEditCard.ieCriteria.inclusion': 'Inclusion',
  'projects.cohortBuilderPage.subjectVariableEditCard.ieCriteria.exclusion': 'Exclusion',
  'projects.cohortBuilderPage.subjectVariableEditCard.allFieldsRequired':
    'All fields are required unless marked optional.',
  'projects.cohortBuilderPage.subjectVariableEditCard.categoryLabel': 'Category',
  'projects.cohortBuilderPage.subjectVariableEditCard.categoryPlaceholder': 'Select category',
  'projects.cohortBuilderPage.subjectVariableEditCard.typeLabel': 'Type',
  'projects.cohortBuilderPage.subjectVariableEditCard.typePlaceholder': 'Select a type',
  'projects.cohortBuilderPage.subjectVariableEditCard.yearsLabel': 'year(s)',
  'projects.cohortBuilderPage.subjectVariableEditCard.occurrencesLabel': 'occurrence(s)',
  'projects.cohortBuilderPage.subjectVariableEditCard.demographicOption': 'Demographic',
  'projects.cohortBuilderPage.subjectVariableEditCard.clinicalOption': 'Clinical',
  'projects.cohortBuilderPage.subjectVariableEditCard.ieCriteria.notApplied': 'Not applied',

  // Demographic filter labels
  'projects.cohortBuilderPage.subjectVariableEditCard.ageAtIndex': 'Age at index',
  'projects.cohortBuilderPage.subjectVariableEditCard.gender': 'Gender',
  'projects.cohortBuilderPage.subjectVariableEditCard.race': 'Race',
  'projects.cohortBuilderPage.subjectVariableEditCard.ethnicity': 'Ethnicity',

  // cohort builder components - SubjectVariableDeleteModal
  'projects.cohortBuilderPage.subjectVariableDeleteModal.title': 'Delete subject variable',
  'projects.cohortBuilderPage.subjectVariableDeleteModal.submittingTitle':
    'Deleting subject variable',

  // Time Window messages
  'projects.cohortBuilderPage.subjectVariableEditCard.timeWindow.title': 'Time window',
  'projects.cohortBuilderPage.subjectVariableEditCard.timeWindow.start': 'Time window start',
  'projects.cohortBuilderPage.subjectVariableEditCard.timeWindow.end': 'Time window end',
  'projects.cohortBuilderPage.subjectVariableEditCard.timeWindow.to': 'to',
  'projects.cohortBuilderPage.subjectVariableEditCard.timeWindow.value': 'Value',
  'projects.cohortBuilderPage.subjectVariableEditCard.timeWindow.day': 'day(s)',
  'projects.cohortBuilderPage.subjectVariableEditCard.timeWindow.days':
    '{count, plural, one {# day} other {# days}}',
  'projects.cohortBuilderPage.subjectVariableEditCard.timeWindow.date': 'Select date',
  'projects.cohortBuilderPage.subjectVariableEditCard.timeWindow.before': 'before',
  'projects.cohortBuilderPage.subjectVariableEditCard.timeWindow.after': 'after',
  'projects.cohortBuilderPage.subjectVariableEditCard.timeWindow.index': 'index',
  'projects.cohortBuilderPage.subjectVariableEditCard.timeWindow.relativeToIndexDate':
    'Relative to index date',
  'projects.cohortBuilderPage.subjectVariableEditCard.timeWindow.calendarDate': 'Calendar date',
  'projects.cohortBuilderPage.subjectVariableEditCard.timeWindow.studyPeriodStart':
    'Study period start',
  'projects.cohortBuilderPage.subjectVariableEditCard.timeWindow.studyPeriodEnd':
    'Study period end',

  // Time Window validation messages
  'projects.cohortBuilderPage.subjectVariableEditCard.timeWindow.validation.startAfterEnd':
    'Time window start must be before time window end.',
  'projects.cohortBuilderPage.subjectVariableEditCard.timeWindow.validation.startOutsideStudyPeriod':
    'Time window start must be within the study period ({startDate} to {endDate}).',
  'projects.cohortBuilderPage.subjectVariableEditCard.timeWindow.validation.endOutsideStudyPeriod':
    'Time window end must be within the study period ({startDate} to {endDate}).',
};
